import axios from 'axios';
import api from './api';

const callaxios = axios.create({
  // baseURL: 'http://3.228.238.128:7016',
  baseURL: api.baseUrl16,
  headers: {
    'content-type': 'html',
    // 'Access-Control-Allow-Origin': 'http://3.228.238.128:7016',
    // 'Access-Control-Allow-Origin': api.baseUrl16,
    // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
    // 'Access-Control-Allow-Headers':
    //   'Content-Type, X-Auth-Token, Origin, Authorization, UserId'
  }
})

// configure headers
callaxios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('LOGGEDIN')) {
      config.headers['Authorization'] =
        'Bearer ' + sessionStorage.getItem('JWT')
      config.headers['UserId'] = sessionStorage.getItem('USERID')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default callaxios
